import { graphqlClient } from '@/lib/graphql-client';
import { buildGetNocTypesQuery } from '../graphql/queries';
import {
  DELETE_NOC_TYPE_MUTATION,
  INSERT_NOC_TYPE_MUTATION,
  UPDATE_NOC_TYPE_MUTATION,
} from '../graphql/mutations';
import {
  GetNocTypesParams,
  NocTypeInsertInput,
  NocTypesPagingResult,
  NocTypeUpdateInput,
} from '../types/noc-type.types';

export const getNocTypes = async (
  params: GetNocTypesParams
): Promise<{ NocTypes: NocTypesPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetNocTypesQuery(filter, pageNo, pageSize, order),
  }) as Promise<{ NocTypes: NocTypesPagingResult }>;
};

export const createNocType = async (input: NocTypeInsertInput) => {
  return graphqlClient.mutate({ query: INSERT_NOC_TYPE_MUTATION, variables: { input } });
};

export const updateNocType = async (params: { itemId: string; input: NocTypeUpdateInput }) => {
  const filter = JSON.stringify({ _id: params.itemId });
  return graphqlClient.mutate({
    query: UPDATE_NOC_TYPE_MUTATION,
    variables: { filter, input: params.input },
  });
};

export const deleteNocType = async (itemId: string) => {
  const filter = JSON.stringify({ _id: itemId });
  return graphqlClient.mutate({
    query: DELETE_NOC_TYPE_MUTATION,
    variables: { filter, input: { isHardDelete: false } },
  });
};
